import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Location } from '@angular/common';
import { UserService } from '../../../providers/user-service/user.service';
import { map } from 'rxjs/operators';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';

@Component({
  selector: 'app-backup-viewer1',
  templateUrl: './backup-viewer1.page.html',
  styleUrls: ['./backup-viewer1.page.scss']
})
export class BackupViewer1Page implements OnInit {
  words = [];

  constructor (
    private navCtrl: NavController,
    private location: Location,
    private userService: UserService,
    private eventLogger: EventLoggerService

  ) { }

  ionViewDidEnter () {
    this.eventLogger.logScreen('backup-viewer#', {});
  }

  ngOnInit () {
    this.userService.getMnemonic().pipe(
      map((mnemonics) => {
        this.words = mnemonics.split(' ');
      })
    )
      .subscribe();
  }

  onClickSortWords () {
    this.navCtrl.navigateForward('/backup-sort');
  }

  onClickNavBack () {
    this.location.back();
  }
}
